import {useEffect, useRef, useState} from 'react';

export const pending = 'pending';
export const resolved = 'resolved';
export const rejected = 'rejected';

export const usePreloadImage = (url: string) => {
  const [status, setStatus] = useState(pending);
  const [counter, setCounter] = useState(0);
  const image = useRef(new Image());

  useEffect(() => {
    setStatus(pending);
    image.current = new Image();
    image.current.src = url;
    image.current.onload = () => setStatus(resolved);
    image.current.onerror = () => setStatus(rejected);
  }, [url, counter]);

  return {
    status,
    image: image.current,
    src: image.current.src,
    width: image.current.width,
    height: image.current.height,
    reload: () => {
      setCounter((v) => v + 1);
      setStatus(pending);
    },
  };
};

export const combineStatuses = (...statuses: string[]) => {
  const possibleStatuses = [rejected, pending, resolved];
  return possibleStatuses.find((status) => statuses.includes(status));
};
